<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "App",
  mounted() {
    // window.onresize = () => {
    //   return (() => {
    //     this.$forceUpdate();//强制更新数据
    //     this.$router.go(0);
    //   })();
    // };
  },
  
  methods: {
    Refresh() {
        this.$router.go(0);
      },
      destroyed() {
      // 销毁
      window.onresize = null;
    }
  }

};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
</style>
